import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <ButtonGroup variant="contained" size="small">
      <Button 
        onClick={() => i18n.changeLanguage('en')}
        disabled={i18n.language === 'en'}
      >
        EN
      </Button>
      <Button 
        onClick={() => i18n.changeLanguage('zh')}
        disabled={i18n.language === 'zh'}
      >
        中文
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher; 